module.exports = __webpack_public_path__ + "img/Img3.e5ebbc04.jpg";